module.exports = __webpack_public_path__ + "static/media/wreath.da52d507.svg";